import React from "react"
import Menu from "./menu"
import FOOTER from '../styles/components/footer.module.scss'

const Footer = (props) => {
    const phoneNumber = JSON.stringify(props.contact.numerTelefonu);
    return (
        <footer className={FOOTER.FOOTER}>
            <nav>
                <Menu nodes={props.menu}/>

                
                <address>
                    <span className="readers_only">
                        {props.contact.osobaKontaktowa}
                    </span>
                    <a href={`tel:${props.contact.numerTelefonu}`}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="23.5" height="26" viewBox="0 0 14.9 13.884"><path d="M6713.461,2666.674a3.7,3.7,0,0,1-2.475,1.742c-.671.061-.671.551-4.4-.917s-6.078-5.289-6.262-5.533a7.127,7.127,0,0,1-1.5-3.791,4.11,4.11,0,0,1,1.283-3.057,1.346,1.346,0,0,1,.978-.458c.245,0,.489.03.7.03s.519-.123.825.611,1.038,2.538,1.13,2.721a.673.673,0,0,1,.031.642,2.494,2.494,0,0,1-.367.611c-.183.215-.385.478-.55.643-.183.182-.374.381-.161.748a11.045,11.045,0,0,0,2.04,2.538,10.027,10.027,0,0,0,2.948,1.819c.367.183.58.153.794-.092s.917-1.069,1.161-1.437.489-.305.825-.183,2.139,1.009,2.5,1.192.611.275.7.428A3.068,3.068,0,0,1,6713.461,2666.674Z" transform="translate(-6698.829 -2654.66)"/></svg>
                        {
                            phoneNumber[0] + phoneNumber[1] + phoneNumber[2] +
                            " "+
                            phoneNumber[3] + phoneNumber[4] + phoneNumber[5] +
                            " "+
                            phoneNumber[6] + phoneNumber[7] + phoneNumber[8]
                        }
                    </a>
                    <p>{props.contact.adres}</p>
                </address>
            </nav>
        </footer>
    )
}

export default Footer